import React from 'react'
import { Tooltip } from '@material-tailwind/react'
import { AiOutlineDownload } from 'react-icons/ai'
import { InfoIcon2, InvoiceIcon, PersonIcon, ProductIcon } from '../../Assets/AllSvg'
import MrrrChart from './MrrrChart'
import { FaLightbulb } from 'react-icons/fa'
import { BsFillChatFill } from 'react-icons/bs'
import { HiChevronUpDown } from 'react-icons/hi2'
import EmptyChart from './EmptyChart'
import RevenueChart from './RevenueChart'
import RetantionTable from '../RetantionTable/RetantionTable'
import GrowthChart from './GrowthChart'

const BillOverview = () => {
    return (
        <div>
            <div className='mt-5'>
                <div className='pb-[12px] border-b-[1px] border-[#ebeef1]'>
                    <span className='text-[#1a1b25] text-[20px] font-bold'>Growth</span>
                </div>
                <div className="grid sm:grid-cols-2 grid-cols-1">
                    <div className='border-b-[1px] sm:border-r-[1px] border-[#ebeef1] pb-3'>
                        <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                            <span className='text-[14px] font-semibold text-[#414552]'>MRR</span>
                            <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                        </div>
                        <div className='max-w-[90%] w-full'>
                            <MrrrChart />
                        </div>
                    </div>
                    <div className='border-b-[1px] border-[#ebeef1] sm:px-4'>
                        <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                            <span className='text-[14px] font-semibold text-[#414552]'>Active subscribers</span>
                            <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                        </div>
                        <div className='max-w-[90%] w-full'>
                            <MrrrChart />
                        </div>
                    </div>
                    <div className='border-b-[1px] sm:border-r-[1px] border-[#ebeef1] pb-3'>
                        <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                            <span className='text-[14px] font-semibold text-[#414552]'>MRR growth</span>
                            <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                        </div>
                        <div className='max-w-[90%] w-full'>
                            <GrowthChart />
                        </div>
                    </div>
                    <div className='border-b-[1px] border-[#ebeef1] sm:px-4'>
                        <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                            <span className='text-[14px] font-semibold text-[#414552]'>Active subscribers</span>
                            <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                        </div>
                        <div className='max-w-[90%] w-full'>
                            <GrowthChart />
                        </div>
                    </div>
                    <div className='border-b-[1px] sm:border-r-[1px] border-[#ebeef1] pb-3'>
                        <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                            <span className='text-[14px] font-semibold text-[#414552]'>Net volume</span>
                            <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                        </div>
                        <div className='max-w-[90%] w-full'>
                            <MrrrChart />
                        </div>
                    </div>
                    <div className='border-b-[1px] border-[#ebeef1] sm:px-4'>
                        <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                            <span className='text-[14px] font-semibold text-[#414552]'>New subscribers</span>
                            <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                        </div>
                        <div className='max-w-[90%] w-full'>
                            <MrrrChart />
                        </div>
                    </div>
                    <div className='border-b-[1px] sm:border-r-[1px] border-[#ebeef1] pb-3'>
                        <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                            <span className='text-[14px] font-semibold text-[#414552]'>New trials</span>
                            <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                        </div>
                        <div className='max-w-[90%] w-full'>
                            <MrrrChart />
                        </div>
                    </div>
                    <div className='border-b-[1px] border-[#ebeef1] sm:px-4'>
                        <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                            <span className='text-[14px] font-semibold text-[#414552]'>Trial conversion rate</span>
                            <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                        </div>
                        <div className='max-w-[90%] w-full'>
                            <MrrrChart />
                        </div>
                    </div>
                </div>
                <div className='mt-4 flex xs:flex-row flex-col gap-2 items-center justify-between rounded-md p-[16px] border-[1px] border-[#d5dbe1]'>
                    <div className='flex items-center sm:gap-1 gap-2 text-[14px] text-[#414552]'>
                        <FaLightbulb className='text-[20px]' />Need help getting started? View recommendations for your business.
                    </div>
                    <button className="input_focus_shadow h-[30px] rounded-[6px] w-max whitespace-nowrap text-[14px] font-semibold p-[0_8px]">See recommendations</button>
                </div>
                <div className="mt-5">
                    <div className="py-[12px] border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                        <span className="text-[#1a1b25] text-[20px] font-bold">Report Downloads</span>
                        <button className='flex gap-1 items-center text-sm font-semibold text-[#625afa]'><BsFillChatFill className='text-[12px] text-[#625afa]' />Send feedback</button>
                    </div>
                    <div className="p-[20px_0] flex justify-between items-center sm:flex-row flex-col gap-2 border-b-[1px] border-[#ebeef1]">
                        <div>
                            <div className='flex gap-2 items-center'>
                                <span className='text-base text-[#1a1b25] font-semibold'>MRR per subscriber per month</span>
                                <Tooltip content="The download will always include your entire account history." className="bg-white text-black shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[12px] max-w-[300px]">
                                    <button><InfoIcon2 /></button>
                                </Tooltip>
                            </div>
                            <span className='text-[#414552] text-sm'>This report includes the MRR for each subscriber at the end of each month.</span>
                        </div>
                        <button className='border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] text-[14px] font-semibold p-[0_8px] flex items-center gap-2 opacity-60' disabled><AiOutlineDownload className="text-base" />Download...</button>
                    </div>
                    <div className="p-[20px_0] flex justify-between items-center sm:flex-row flex-col border-b-[1px] border-[#ebeef1]">
                        <div>
                            <div className='flex gap-2 items-center'>
                                <span className='text-base text-[#1a1b25] font-semibold'>Subscription metrics per month</span>
                                <Tooltip content="The download will always include your entire account history." className="bg-white text-black shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[12px] max-w-[300px]">
                                    <button><InfoIcon2 /></button>
                                </Tooltip>
                            </div>
                            <span className='text-[#414552] text-sm'>This report includes high-level subscription metrics with monthly granularity.</span>
                        </div>
                        <button className='border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] text-[14px] font-semibold p-[0_8px] flex items-center gap-2 opacity-60' disabled><AiOutlineDownload className="text-base" />Download...</button>
                    </div>
                </div>
                <div className="mt-10">
                    <div className="pb-[12px] border-b-[1px] border-[#ebeef1]">
                        <span className="text-[#1a1b25] text-[20px] font-bold">Products</span>
                    </div>
                    <div className='flex justify-between items-center xs:flex-row gap-2 flex-col py-[16px]'>
                        <div className='flex items-center gap-3'>
                            <div className="relative mt-1 w-[118px]">
                                <select className="input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[14px] appearance-none">
                                    <option value="MRR">MRR</option>
                                    <option value="Subscriptions">Subscriptions</option>
                                </select>
                                <HiChevronUpDown className='absolute top-[2px] right-0 flex items-center pr-1 text-[25px]' />
                            </div>
                            <span className='text-sm'>by</span>
                            <div className="relative mt-1 w-[90px]">
                                <select className="input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[14px] appearance-none">
                                    <option value="Product">Product</option>
                                    <option value="Plan">Plan</option>
                                </select>
                                <HiChevronUpDown className='absolute top-[2px] right-0 flex items-center pr-1 text-[25px]' />
                            </div>
                        </div>
                        <span className="text-[12px] text-[#687385]">Data as of May 23</span>
                    </div>
                    <div className="grid md:grid-cols-2 grid-cols-1">
                        <div className='border-t-[1px] border-[#ebeef1] p-[8px]'>
                            <div className="flex justify-between">
                                <span className="text-[11px] font-medium text-[#1a1b25]">PRODUCT</span>
                                <span className="text-[11px] font-medium text-[#1a1b25]">SUBSCRIPTIONS</span>
                            </div>
                            <div className='flex flex-col items-center justify-center p-[48px_20px] gap-3'>
                                <ProductIcon className="h-[32px] w-[32px] fill-gray-600" />
                                <span className='text-[#687385] font-semibold text-sm'>There are no products with MRR</span>
                            </div>
                        </div>
                        <div>
                            <EmptyChart />
                        </div>
                    </div>
                </div>
                <div className="mt-8">
                    <div className='pb-[12px] border-b-[1px] border-[#ebeef1]'>
                        <span className='text-[#1a1b25] text-[20px] font-bold'>Retention</span>
                    </div>
                    <div className="grid sm:grid-cols-2 grid-cols-1">
                        <div className='border-b-[1px] border-r-[1px] border-[#ebeef1] pb-3'>
                            <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                                <span className='text-[14px] font-semibold text-[#414552]'>Subscriber churn rate</span>
                                <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                            </div>
                            <div className='max-w-[90%] w-full'>
                                <MrrrChart />
                            </div>
                        </div>
                        <div className='border-b-[1px] border-[#ebeef1] px-4'>
                            <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                                <span className='text-[14px] font-semibold text-[#414552]'>Churned revenue</span>
                                <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                            </div>
                            <div className='max-w-[90%] w-full'>
                                <MrrrChart />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-4">
                    <RetantionTable />
                </div>
                <div className="mt-8">
                    <div className='pb-[12px] border-b-[1px] border-[#ebeef1]'>
                        <span className='text-[#1a1b25] text-[20px] font-bold'>Subscribers</span>
                    </div>
                    <div className="grid sm:grid-cols-2 grid-cols-1">
                        <div className='border-b-[1px] sm:border-r-[1px] border-[#ebeef1] pb-3'>
                            <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                                <span className='text-[14px] font-semibold text-[#414552]'>Average revenue per subscriber</span>
                                <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                            </div>
                            <div className='max-w-[90%] w-full'>
                                <MrrrChart />
                            </div>
                        </div>
                        <div className='border-b-[1px] border-[#ebeef1] px-4'>
                            <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                                <span className='text-[14px] font-semibold text-[#414552]'>Subscriber lifetime value</span>
                                <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                            </div>
                            <div className='max-w-[90%] w-full'>
                                <MrrrChart />
                            </div>
                        </div>
                        <div className='border-b-[1px] sm:border-r-[1px] border-[#ebeef1] pb-3'>
                            <div className='flex justify-between items-center py-[16px] sm:pr-[16px] border-b-[1px] border-[#ebeef1]'>
                                <span className='text-[14px] font-semibold text-[#414552]'>Top subscribers</span>
                            </div>
                            <div className='flex justify-between items-center py-[10px] pr-[16px]'>
                                <span className='text-[11px] font-semibold text-[#414552]'>CUSTOMER</span>
                                <span className='text-[11px] font-semibold text-[#414552]'>TOTAL PAID</span>
                            </div>
                            <div className="sm:h-[360px] h-[200px] flex justify-center items-center gap-3 flex-col">
                                <PersonIcon className="fill-gray-600 h-[32px] w-[32px]" />
                                <span className="text-[#687385] font-semibold text-sm">No active subscribers</span>
                            </div>
                        </div>
                        <div className='border-b-[1px] border-[#ebeef1] pb-3'>
                            <div className='flex justify-between items-center py-[16px] pl-[16px] border-b-[1px] border-[#ebeef1]'>
                                <span className='text-[14px] font-semibold text-[#414552]'>Top subscribers</span>
                            </div>
                            <div className='flex justify-between items-center py-[10px] pl-[16px]'>
                                <span className='text-[11px] font-semibold text-[#414552]'>CUSTOMER</span>
                                <div className='flex gap-3'>
                                    <span className='text-[11px] font-semibold text-[#414552]'>MRR</span>
                                    <span className='text-[11px] font-semibold text-[#414552]'>REASON</span>
                                </div>
                            </div>
                            <div className="sm:h-[360px] h-[200px] flex justify-center items-center gap-3 flex-col">
                                <PersonIcon className="fill-gray-600 h-[32px] w-[32px]" />
                                <span className="text-[#687385] font-semibold text-sm">No churned subscribers</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-8">
                    <div className='pb-[12px] border-b-[1px] border-[#ebeef1]'>
                        <span className='text-[#1a1b25] text-[20px] font-bold'>Collections</span>
                    </div>
                    <div className="grid sm:grid-cols-2 grid-cols-1">
                        <div className='border-b-[1px] border-[#ebeef1] pb-3'>
                            <div className='flex justify-between items-center py-[16px] sm:pr-[16px] border-b-[1px] border-[#ebeef1]'>
                                <span className='text-[14px] font-semibold text-[#414552]'>Outstanding invoices</span>
                            </div>
                            <div className='flex justify-between items-center py-[10px] pr-[16px]'>
                                <span className='text-[11px] font-semibold text-[#414552]'>INVOICE AGE</span>
                                <div className='flex gap-3'>
                                    <span className='text-[11px] font-semibold text-[#414552]'>INVOICES</span>
                                    <span className='text-[11px] font-semibold text-[#414552]'>AMOUNT</span>
                                </div>
                            </div>
                            <div className="h-[160px] flex justify-center items-center gap-3 flex-col">
                                <InvoiceIcon className="fill-gray-600 h-[32px] w-[32px]" />
                                <span className="text-[#687385] font-semibold text-sm">No invoices due</span>
                            </div>
                        </div>
                        <div className='border-b-[1px] border-[#ebeef1] px-4'>
                            <div className='flex justify-between items-center py-[16px] sm:pr-[16px]'>
                                <span className='text-[14px] font-semibold text-[#414552]'>Recovered revenue</span>
                                <span className='text-[12px] text-[#687385]'>Data as of May 23</span>
                            </div>
                            <div className='max-w-[90%] w-full'>
                                <RevenueChart />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BillOverview